import Http from '../utilities/Http';
import {API_ROOT} from '../config';

export default {
	async getMarkets(organizationId, search, startDate, endDate, perPage = null, currentPage = null, ordering = null) {
		let params = {
			search,
			startDate,
			endDate,
			perPage,
			currentPage
		};

		if (ordering && ordering.length > 0) {
			params.ordering = JSON.stringify(ordering);
		}

		let response = await Http().get(API_ROOT + '/organizations/' + organizationId + '/markets', {
			params
		});

		return response.data;
	}
};
